import React from 'react';
import classNames from 'classnames';
import { PaymentMethodModel } from 'Douleutaras/types';
import Tooltip from 'Douleutaras/components/Tooltip/Tooltip';

import './PaymentMethods.scss';

export const PaymentMethods = ({ methods = [], large }: { methods: Array<PaymentMethodModel>; large?: boolean }) => {
  if (!methods.length) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <div styleName={classNames('payment-methods__container', { 'payment-methods__container--large': large === true })}>
      { [...methods]
        .sort((a, b) => a.order - b.order)
        .map(method => (
          <div styleName="payment-methods__item" key={method.name}>
            <Tooltip content={method.tooltip} direction="top">
              <img src={method.icon} alt={method.tooltip} />
            </Tooltip>
          </div>
      )) }
    </div>
  );
};
